import { SelectProps } from 'antd';
import { BaseSelectRef } from 'rc-select/lib/BaseSelect';
import { forwardRef, useCallback } from 'react';

import { useBrandsInSelectFieldLazyQuery } from '../../graphql/brands.generated';
import AsyncSelect from '../Input/AsyncSelect';

export type SelectFieldProps = SelectProps & {
  initialOption?: { value: number; label: string };
  initialLoad?: boolean;
};

const BrandSelect = forwardRef<BaseSelectRef, SelectFieldProps>(function (
  { initialLoad, ...props },
  ref
) {
  const [fetchBrands] = useBrandsInSelectFieldLazyQuery({
    fetchPolicy: 'no-cache',
  });

  const fetchItems = useCallback(
    async (name: string) => {
      const { data } = await fetchBrands({
        variables: {
          filter: { name },
          pagination: { take: 20, skip: 0 },
        },
      });

      return (data?.adminBrands.edges || []).map((edge) => {
        return {
          label: edge.node.name,
          value: edge.node.id,
          data: edge.node,
        };
      });
    },
    [fetchBrands]
  );

  return (
    <AsyncSelect
      ref={ref}
      initialLoad={initialLoad}
      className={'w-full'}
      fetchItems={fetchItems}
      {...props}
    />
  );
});

export default BrandSelect;
